import { Injectable } from '@angular/core';

@Injectable()
export class ScriptLoaderService {
  constructor() {}

  loadScript(name: string, id: string) {
    const script: any = document.createElement('script');
    script.type = 'text/javascript';
    script.src = name;
    console.log(window.frames['frame']);
    const iframe: any = window.frames['frame'].getElementsByTagName('head')[0];
    console.log(document.getElementById(id));
  }
}
